export type IconProps = {
  id?: string;
  size?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
};

export const defaultIconProps: IconProps = {
  size: 20,
  strokeWidth: 1,
};
